import React from 'react'
import { useParams } from 'react-router-dom'

function SriLankaAbout() {
  return (
    <div
      className="container-fluid py-5"
      style={{
        backgroundImage: "url('/assets/img/srilanka.png')",
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        position: 'relative'
      }}
    >
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,102,122,0.6)' }} />
      <div className="container position-relative text-center text-white" style={{ zIndex: 5, padding: '80px 0' }}>
        <h1 style={{ fontWeight: 600, fontSize: 48 }}>
          About <span style={{ fontStyle: 'italic' }}>Sri Lanka</span>
        </h1>
        <p style={{ maxWidth: 1000, margin: '24px auto 0', lineHeight: 1.8 }}>
          Experience the best of Sri Lanka from the world-famous Cultural Triangle
          and misty tea plantations to sun-kissed beaches, thrilling wildlife
          safaris, and rejuvenating Ayurveda wellness retreats. At Ceylonsman, we
          design customized Sri Lanka tours that reflect your interests, travel
          style, and budget. Our Sri Lanka travel specialists know the island
          inside out, guiding you to authentic experiences beyond the guidebooks.
        </p>
      </div>
    </div>
  )
}

function WhyTravelWithCeylonsman() {
  return (
    <div className="container my-5 text-center">
      <h2 style={{ fontWeight: 700, marginBottom: 10 }}>Why Travel with Ceylonsman?</h2>
      <p style={{ color: '#666', maxWidth: 900, margin: '8px auto 24px' }}>
        We create personalized itineraries for every traveller. Whether you're looking for
        luxury, adventure, or wellness, our local experts design experiences just for you.
      </p>

      <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', flexWrap: 'wrap', gap: 24 }}>
        <div style={{ width: 160 }}>
          <div style={{ fontSize: 28, color: 'var(--secondary)', marginBottom: 8 }}>💎</div>
          <div style={{ fontWeight: 600 }}>Luxury holidays in Sri Lanka</div>
        </div>

        <div style={{ width: 160 }}>
          <div style={{ fontSize: 28, color: 'var(--secondary)', marginBottom: 8 }}>👪</div>
          <div style={{ fontWeight: 600 }}>Family-friendly tours</div>
        </div>

        <div style={{ width: 160 }}>
          <div style={{ fontSize: 28, color: 'var(--secondary)', marginBottom: 8 }}>🦁</div>
          <div style={{ fontWeight: 600 }}>Wildlife adventures</div>
        </div>

        <div style={{ width: 160 }}>
          <div style={{ fontSize: 28, color: 'var(--secondary)', marginBottom: 8 }}>🌿</div>
          <div style={{ fontWeight: 600 }}>Ayurveda & wellness escapes</div>
        </div>

        <div style={{ width: 160 }}>
          <div style={{ fontSize: 28, color: 'var(--secondary)', marginBottom: 8 }}>🏖️</div>
          <div style={{ fontWeight: 600 }}>Beach vacations</div>
        </div>
      </div>
    </div>
  )
}

function SriLankaTopExperiences() {
  const experiences = [
    { title: 'Cultural Wonders', text: 'Explore the Cultural Triangle: Dambulla, Sigiriya and Polonnaruwa.', img: 'assets/img/destination-1.jpg' },
    { title: 'Wildlife Safaris', text: 'Spot elephants, exotic birds, and leopards in Yala or Wilpattu.', img: 'assets/img/destination-2.jpg' },
    { title: 'Tea Country Escapes', text: 'Wander Nuwara Eliya and colonial plantation bungalows.', img: 'assets/img/destination-3.jpg' },
    { title: 'Ayurveda & Wellness', text: 'Indulge in authentic Ayurvedic treatments and yoga retreats.', img: 'assets/img/package-1.jpg' },
    { title: 'Cultural Immersion', text: 'Hands-on experiences: cooking, pottery, village walks and homestays.', img: 'assets/img/package-2.jpg' },
    { title: 'Beach Bliss', text: 'Relax on beaches in Bentota, Mirissa, or Trincomalee.', img: 'assets/img/package-3.jpg' }
  ]

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4" style={{ fontWeight: 700 }}>Top Experiences in Sri Lanka</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 24 }}>
        {experiences.map((ex, idx) => (
          <div key={idx} style={{ borderRadius: 12, overflow: 'hidden', position: 'relative', minHeight: 180, backgroundImage: `url('/${ex.img}')`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(0,0,0,0.25), rgba(0,0,0,0.6))' }} />
            <div style={{ position: 'absolute', bottom: 18, left: 18, color: '#fff', right: 18 }}>
              <h4 style={{ margin: 0 }}>{ex.title}</h4>
              <p style={{ marginTop: 8, marginBottom: 0, fontSize: 14, lineHeight: 1.4 }}>{ex.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}


function SriLankaTabs() {
  return (
    <div className="container my-4">
      <div style={{ display: 'flex', gap: 40, justifyContent: 'center', alignItems: 'center' }}>
        <button style={{ background: '#ff9a00', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: 8 }}>Sri Lanka Holiday</button>
        <button style={{ background: 'transparent', color: '#333', border: 'none' }}>Travel Themes</button>
        <button style={{ background: 'transparent', color: '#333', border: 'none' }}>Transportation</button>
        <button style={{ background: 'transparent', color: '#333', border: 'none' }}>Travel Guides</button>
      </div>
    </div>
  )
}

function Destination() {
  const { place } = useParams()

  const placeSlugToDisplay = (slug) => {
    if (!slug) return null
    // simple mapping for display name
    const map = {
      srilanka: 'Sri Lanka',
      maldives: 'Maldives'
    }
    return map[slug.toLowerCase()] || slug.charAt(0).toUpperCase() + slug.slice(1)
  }

  const placeDisplay = placeSlugToDisplay(place)
  return (
    <div>
        <div className={`container-fluid py-5 mb-5 hero-header ${placeDisplay ? 'hero-header-custom' : 'bg-primary'}`}>
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
            {placeDisplay || 'Destination'}
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Destination
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
      {/* Destination Start */}
      <div className="container-xxl py-5 destination">
        {place === 'srilanka' && <SriLankaTabs />}
        {place === 'srilanka' && <SriLankaAbout />}
        {place === 'srilanka' && <WhyTravelWithCeylonsman />}
        {place === 'srilanka' && <SriLankaTopExperiences />}
        {placeDisplay && (
          <style>{`
            .hero-header-custom { background-image: url('/assets/img/${place}.png'); background-size: cover; background-position:center; }
          `}</style>
        )}
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Destination
          </h6>
          <h1 className="mb-5">Popular Destination</h1>
        </div>
        <div className="row g-3">
          <div className="col-lg-7 col-md-6">
            <div className="row g-3">
              <div
                className="col-lg-12 col-md-12 wow zoomIn"
                data-wow-delay="0.1s"
              >
               
                <a
                  className="position-relative d-block overflow-hidden"
                  href="https//facebook.com"
                >
                  <img
                    className="img-fluid"
                    src="assets/img/destination-1.jpg"
                    alt=""
                  />
                  <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
                    30% OFF
                  </div>
                  <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                    Thailand
                  </div>
                </a>
              </div>
              <div
                className="col-lg-6 col-md-12 wow zoomIn"
                data-wow-delay="0.3s"
              >
               
                <a
                  className="position-relative d-block overflow-hidden"
                  href="https//facebook.com"
                >
                  <img
                    className="img-fluid"
                    src="assets/img/destination-2.jpg"
                    alt=""
                  />
                  <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
                    25% OFF
                  </div>
                  <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                    Malaysia
                  </div>
                </a>
              </div>
              <div
                className="col-lg-6 col-md-12 wow zoomIn"
                data-wow-delay="0.5s"
              >
               
                <a
                  className="position-relative d-block overflow-hidden"
                  href="https//facebook.com"
                >
                  <img
                    className="img-fluid"
                    src="assets/img/destination-3.jpg"
                    alt=""
                  />
                  <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
                    35% OFF
                  </div>
                  <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                    Australia
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div
            className="col-lg-5 col-md-6 wow zoomIn"
            data-wow-delay="0.7s"
            style={{ minHeight: 350 }}
          >
            
            <a
              className="position-relative d-block h-100 overflow-hidden"
              href="https//facebook.com"
            >
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/destination-4.jpg"
                alt=""
                style={{ objectFit: "cover" }}
              />
              <div className="bg-white text-danger fw-bold position-absolute top-0 start-0 m-3 py-1 px-2">
                20% OFF
              </div>
              <div className="bg-white text-primary fw-bold position-absolute bottom-0 end-0 m-3 py-1 px-2">
                Indonesia
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    {/* Destination Start */}
    </div>
  )
}

export default Destination
